import styled from "styled-components";
import {FieldMap, FieldMapGroups, FieldMapValue} from "../../../Types";
import {ICONS, LANG, SELECT_BACK_COLOR} from "../../CONSTANTS";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


export default function FieldMapView({map}: { map: FieldMap }) {


    return <Container>
        {map.async &&
            <div><span className={'async-map'}>Асинхронно</span><span> - {map.async}</span></div>}
        {map.async && !map.values &&
            <div>Значення поки не завантажені</div>}
        {map.groups && map.values && renderGroups(map, map.backgroundColor || SELECT_BACK_COLOR)}
        <div className={'values'}>
            {!map.groups && map.values && Object.values(map.values).map(v => renderValue(v, map.backgroundColor || SELECT_BACK_COLOR))}
        </div>
    </Container>
}

function renderGroups(map: FieldMap, bg = SELECT_BACK_COLOR) {


    return <div className={'groups'}>

        {map.groups!.map((g, i) => <div key={i}>
            <div>Група - {g.label[LANG]}</div>
            <div className={'values'} style={{marginLeft: ".5rem", marginTop: ".5rem"}}>
                {g.values.map(gv => renderValue(map.values[gv], bg))}
            </div>
        </div>)}
    </div>
}

function renderValue(v: FieldMapValue, bg = SELECT_BACK_COLOR) {

    return <div className={'value'} key={v.rawValue} style={{background: bg, color: v.color}}>
        {v.lang[LANG]} {v.icon && <>- <FontAwesomeIcon icon={ICONS[v.icon]}/> </>} - {v.rawValue}
    </div>
}

const Container = styled.div`

    display: flex;
    flex-flow: column;
    gap: .5rem;

    .groups {
        display: flex;
        flex-flow: column;
        gap: .5rem;
    }

    .async-map {
        font-style: italic;
        color: blueviolet;
        font-weight: bold;
        background: #d5c1c1;
        padding: .2rem .4rem;
        border-radius: .2rem;
        line-height: 2;
    }

    .values {
        display: flex;
        flex-wrap: wrap;
        gap: .5rem;

        .value {
            padding: .2rem;
            border-radius: .2rem;
            color: var(--table-row-text-color);
        }
    }
`
